// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","closeIcon":"Modal_closeIcon__9I0vC","icon":"Modal_icon__2UpwH"};